import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);
export const getProjects = () => axios.get(`${API}/projects`).then((r) => r.data);
export const postLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
